import React from 'react';
import { CircularLoading } from 'respinner';

import styles from './Loader.scss';
import Locale from '../../Translate';

type LoaderProps = {
  color?: string;
  loadingText?: string;
};

const Loader = ({ color = '#4197ff', loadingText }: LoaderProps) => (
  <div className={styles.container} aria-label="loader">
    <CircularLoading className={styles.loader} stroke={color} />
    {loadingText && (
      <div className={styles.loadingText}>
        <Locale>{loadingText}</Locale>
      </div>
    )}
  </div>
);

export default Loader;
